import { REFRESH_DASHBOARD_COMPLETE, REFRESH_DASHBOARD } from '../Dashboard.reducer';

export const refreshDashboard = () => ({
  type: REFRESH_DASHBOARD
});

export const refreshDashboardComplete = () => ({
  type: REFRESH_DASHBOARD_COMPLETE
});